import { formatPercent } from '@angular/common';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Locale } from '@rd/types';
import { Subscription } from 'rxjs';
import { getLocaleSelected } from '../../locale/store/selectors/locale.selectors';
import { CoreState } from '../../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class PercentService {
  currentLocale$: Subscription;
  currentLocale: Locale | null;

  constructor(private store: Store<CoreState>) {
    this.currentLocale$ = this.store
      .select(getLocaleSelected)
      .subscribe((locale: Locale | null) => {
        this.currentLocale = locale;
      });
  }

  formatPercent(value: number, digitsInfo?: string): string {
    return this.currentLocale
      ? formatPercent(value, this.currentLocale.code, digitsInfo)
      : '';
  }
}
